// src/components/sections/HeroVideo.jsx
import React from "react";
import { useTranslation } from "react-i18next";
import headerVideo from "../../assets/video/headerintro.mp4";
import arrowDown from "../../assets/icon/vectorarrowdown.svg";
import ExploreButton from "../common/ExploreButton";
import SparkleButton from "../common/SparkleButton";

export default function HeroVideo() {
  const { t, i18n } = useTranslation();
  const isVI = (i18n.resolvedLanguage || i18n.language || "vi").startsWith(
    "vi"
  );

  const goTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section className="relative overflow-hidden h-[560px] mobile:h-[680px] tabletpro:h-[860px] tabletair:h-[820px] tabletmini:h-[780px] desktop:h-[960px]">
      <video
        className="absolute inset-0 w-full h-full object-cover"
        src={headerVideo}
        autoPlay
        muted
        loop
        playsInline
        preload="metadata"
      />

      {/* overlay đen mờ, nằm sau content */}
      <div className="absolute inset-0 bg-black/50 z-[1]" aria-hidden="true" />

      {/* Content */}
      <div className="relative z-10 mx-auto max-w-[1400px] px-4 bottom-[-30%] mobile:bottom-[-25%] gap-[22px] flex flex-col items-center justify-center text-center">
        <h1 className="text-[72px] tabletair:text-[64px] tabletmini:text-[56px] mobile:text-[48px] font-extrabold tracking-tight leading-[80px]">
          <span
            className="
            bg-gradient-to-b from-[#006EEF] via-[#87BDFE] to-[#FFFFFF]
            bg-clip-text text-transparent font-manrope font-extrabold
            "
          >
            {t("header.hero.brand", { defaultValue: "QUANTERA" })}
          </span>
        </h1>

        <p className="mt-4 mobile:mt-1 text-[56px] tabletair:text-[40px] tabletmini:text-[32px] mobile:text-[24px] font-bold text-white leading-tight">
          {isVI ? (
            <>
              <span className="block font-manrope font-700">
                {t("header.hero.headline1", {
                  defaultValue: "NỀN TẢNG DANH TÍNH SỐ & KÝ SỐ",
                })}
              </span>
              <span className="block font-manrope font-700">
                {t("header.hero.headline2", {
                  defaultValue: "TỰ CHỦ TIÊN PHONG",
                })}
              </span>
            </>
          ) : (
            t("header.hero.headline font-manrope font-700", {
              defaultValue:
                "PIONEERING SELF-SOVEREIGN DIGITAL IDENTITY & E-SIGNATURE PLATFORM",
            })
          )}
        </p>

        <p className="mt-4 mobile:mt-1 text-[20px] font-normal tabletair:text-[16px] tabletmini:text-[12px] mobile:text-[16px] text-neutral-3 whitespace-pre-line">
          {t("header.hero.sub", {
            defaultValue:
              "Giải pháp toàn diện cho chính phủ điện tử, eKYC, eID, Tài chính số, Giáo dục và Dịch vụ số.",
          })}
        </p>

        <div className="mt-8 mobile:mt-1 flex flex-col sm:flex-row items-center gap-4">
          <SparkleButton
            onClick={() => goTo("contact")}
            className="text-[16px] font-normal tabletair:text-[12px] tabletmini:text-[10px] mobile:text-[14px]"
          >
            {t("header.hero.trynow", {
              defaultValue: "Đăng ký trải nghiệm ngay",
            })}
          </SparkleButton>

          <ExploreButton
            onClick={() => goTo("solutions")}
            className="text-[16px] font-normal tabletair:text-[12px] tabletmini:text-[10px] mobile:text-[14px]"
          >
            {t("header.hero.explore", { defaultValue: "Khám phá giải pháp" })}
          </ExploreButton>
        </div>
      </div>

      {/* Scroll hint */}
      <button
        onClick={() => goTo("about")}
        className="absolute bottom-4 left-1/2 -translate-x-1/2 z-10 inline-flex h-10 w-10 items-center justify-center"
        aria-label="Scroll down"
        title="Scroll"
      >
        <img
          src={arrowDown}
          alt="Arrow pointing down"
          className="h-8 w-8 mobile:h-6 mobile:w-6 tabletmini:mt-2 tabletair:mt-2 mobile:mt-4 select-none pointer-events-none"
          draggable="false"
        />
      </button>
    </section>
  );
}
